import { cardOutline, logoGoogle, logoApple, logoPaypal, logoAlipay, logoWechat, businessOutline,
        business, colorWandOutline, receiptOutline, } from 'ionicons/icons';

export default {  
  versionCode: '1.0.0',

  Firebase: {
    apiKey: "AIzaSyBmfzixbgxele0AA9n-88al-8vkc1A-4SQ",
    authDomain: "tridacnabeauty.firebaseapp.com",
    projectId: "tridacnabeauty",
    storageBucket: "tridacnabeauty.appspot.com",
    messagingSenderId: "340236327151",
    appId: "1:340236327151:web:5402ac02c452d8d002a31a",
    measurementId: "G-XRM04GZPF9"
  },

  Stripe: {
    publishableKey: 'pk_test_51HVue8F5eqkgmghRoS3cNn8SMdn9ou9PIffiirbX1a4BvdgPSgCGHWvX6EO4XQF6ppPZdkFxyJHE8MmwGs2aby8P00g5qBbCG0', // test
    //publishableKey: 'pk_live_51HVue8F5eqkgmghRn1B9EOEvN9FLUN1kshEHg7xRYqmP8OT2YaBraba2PVCqLqH6GY2EuaQH3CpcuKFM1uS8QdFu00W7JYQlu1', // live
  },

  paymentMethods: [
    //{ label: "信用卡付款", value: "card", icon: cardOutline, transactionFee: 5, },
    { label: "PayPal / 信用卡付款", value: "paypal", icon: logoPaypal, transactionFee: 5 },
    { label: "PayMe", value: "payme", icon: businessOutline },
    { label: "FPS / 銀行過數", value: "bank", icon: businessOutline },
    //{ key: "Google Pay", value: "googlePay", icon: logoGoogle },
    //{ key: "Apple Pay", value: "applePay", icon: logoApple },
    /*{ key: "PayPal", value: "paypal", icon: logoPaypal },
    { key: "AlipayHK", value: "alipayhk", icon: logoAlipay },
    { key: "WeChat Pay HK", value: "wechatpayhk", icon: logoWechat },
    { key: "Bank Transfer", value: "bank", icon: businessOutline },*/
  ],
}